import React from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-16 px-4 bg-surface text-center relative overflow-hidden" data-id="element-46">
      <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-mint via-transparent to-transparent" data-id="element-47" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-48">
        <FadeIn data-id="element-49">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-mint mb-6" data-id="element-50">
            SALUD EN TU PLATO™
          </h2>

          <p className="text-xl md:text-2xl text-white/80 font-medium mb-8 leading-relaxed max-w-3xl mx-auto" data-id="element-51">
            El próximo domingo podés seguir armando planes desde cero. O podés
            tener un sistema para entrar a consulta y resolver con criterio,
            claridad y velocidad.
          </p>

          <a href="https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNAwU2fxxoZKry1E28dbN7i/es-ar?_r=AQABUz-DDfQSB1cPsEXTz0QcvPazglRT5B40d_lxn2LWtqI&cart_link_id=psdRzX2L&preview_theme_id=151828791463" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-mint hover:bg-mint/80 text-black font-bold text-xl py-5 px-10 md:px-16 rounded-xl shadow-2xl shadow-mint/10 transition-all hover:scale-105" data-id="element-52">
            🚀→ QUIERO MI MEGAPACK NUTRIPRO PLUS AHORA
          </a>
        </FadeIn>
      </div>
    </section>;
}